"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ImageThumbnailTransform;

var _core = require("@material-ui/core");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = require("@edaun/admin-helpers/build/main/index");

var _pipe = _interopRequireDefault(require("lodash/fp/pipe"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useStyle = (0, _core.makeStyles)(function (theme) {
  return {
    image: {
      maxWidth: "45px",
      maxHeight: "45px"
    },
    imageContainer: {
      width: "45px",
      height: "45px",
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "center",
      borderRadius: "8px",
      margin: "auto",
      marginRight: 10
    },
    link: {
      maxHeight: "100%",
      overflow: "hidden"
    }
  };
});

function ImageThumbnailTransform(_ref) {
  var src = _ref.src,
      alt = _ref.alt;
  var classes = useStyle();
  var transformedSrc = (0, _pipe["default"])(_index.formatTransformUrl, (0, _index.formatResizeUrl)({
    width: null,
    height: 250
  }))(src);
  var transformedAlt = (0, _pipe["default"])(_index.formatTransformUrl, (0, _index.formatResizeUrl)({
    width: null,
    height: 250
  }))(alt);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.imageContainer
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: classes.link,
    href: src,
    target: "_blank"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: classes.image,
    src: transformedSrc,
    alt: transformedAlt || transformedSrc
  })));
}

ImageThumbnailTransform.propTypes = {
  /**
   * image url
   */
  src: _propTypes["default"].string,

  /**
   * alternative text if image doesn't exist
   */
  alt: _propTypes["default"].string
};